import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

import { PileService } from '../proxy/planning/controllers/pile.service';
import { LocationService } from '../proxy/planning/controllers/location.service';
FieldBuilder.setNamespace('Planning');

export const PILEDETAIL_FIELDS: FieldDefinition[] = [
  FieldBuilder.foreignKey('pileId', 'Entity.Pile', PileService)
    .displayFromNested('pile.name')
    .sortBy('pile.name')
    .hideInChildForms()
    .build(),
  FieldBuilder.foreignKey('locationId', 'Entity.Location', LocationService)
    .displayFromNested('location.name')
    .sortBy('location.name')
    .build(),
];

export const PILEDETAIL_CONFIG = {
  entityName: 'PileDetail',
  localizationKey: 'Planning::Entity.PileDetail',
  fields: PILEDETAIL_FIELDS,
  permission: 'Planning.PileDetails',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Location + MENU_NAME_SUFFIX,
};
